import { useEffect, useState } from 'react'
import { useAuthStore } from '@/store/authStore'
import { partnerApi } from '@/services/api/partner'
import { partnerBillingApi, type BillingInvoice } from '@/services/api/billing'
import { Button, Input } from '@/components/common'
import { extractErrorMessage } from '@/utils/errorHandler'

export function PartnerBillingPage() {
  const user = useAuthStore((s) => s.user)
  const owner = user?.partner_level === 'owner'
  const [rows, setRows] = useState<BillingInvoice[]>([])
  const [overdue, setOverdue] = useState<any>(null)
  const [schools, setSchools] = useState<{ id: string; name: string }[]>([])
  const [dealSchool, setDealSchool] = useState('')
  const [dealPct, setDealPct] = useState('0')
  const [error, setError] = useState<string | null>(null)

  const load = () => {
    partnerBillingApi.invoices().then(setRows).catch(() => setRows([]))
    partnerApi.listSchools().then((s) => setSchools(s.map((x) => ({ id: x.id, name: x.name })))).catch(() => undefined)
    if (owner) partnerBillingApi.overdue().then(setOverdue).catch(() => undefined)
  }
  useEffect(() => { load() }, [owner])

  return (
    <div className="p-6 max-w-6xl">
      <h1 className="text-2xl font-bold mb-4">Abrechnung</h1>
      {error && <p className="text-red-600 mb-3">{error}</p>}
      {owner && overdue && (
        <div className="mb-4">
          <p className="mb-2">Schulen im Verzug: {overdue.count}</p>
          {(overdue.schools || []).length > 0 && (
            <table className="w-full text-sm mb-4">
              <thead><tr className="text-left border-b"><th className="py-2">Schule</th><th>Offen</th><th>Fällig</th><th>Tickets</th></tr></thead>
              <tbody>
                {(overdue.schools || []).map((s: any) => (
                  <tr key={s.school_id} className="border-b">
                    <td className="py-2">{s.school_name}</td>
                    <td>{s.open_amount} {s.currency}</td>
                    <td>{s.oldest_due_at}</td>
                    <td>{s.ticket_lifetime}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
      {owner && (
        <div className="mb-4 flex gap-2 items-end">
          <select className="border rounded px-2 py-1" value={dealSchool} onChange={(e) => setDealSchool(e.target.value)}>
            <option value="">Schule</option>
            {schools.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          <Input placeholder="Deal %" value={dealPct} onChange={(e) => setDealPct(e.target.value)} />
          <Button size="sm" onClick={() => {
            if (!dealSchool) { setError('Schule wählen'); return }
            partnerBillingApi.deal(dealSchool, Number(dealPct)).then(() => { setError(null); load() }).catch((e) => setError(extractErrorMessage(e, { loadError: 'Deal fehlgeschlagen' })))
          }}>Deal setzen</Button>
        </div>
      )}
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left border-b">
            <th className="py-2">Schule</th><th>Nr.</th><th>Periode</th><th>Betrag</th><th>Fällig</th><th>Status</th>
            {owner && <th>Provision</th>}
            {owner && <th>Tickets</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((inv) => (
            <tr key={inv.id} className="border-b">
              <td className="py-2">{inv.school_name}</td>
              <td>{inv.number}</td>
              <td>{inv.period_month}/{inv.period_year}</td>
              <td>{inv.gross} {inv.currency}</td>
              <td>{inv.due_at ? String(inv.due_at).slice(0, 10) : ''}</td>
              <td>{inv.status}</td>
              {owner && <td>{inv.commission_amount ?? '—'}</td>}
              {owner && <td>{inv.ticket_lifetime ?? '—'}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
